export default {
  meEndpoint: "/auth/me",
  storageTokenKeyName: "beemz-admin-accessToken",
  storageUserDataKeyName: "beemz-admin-userData",
  storageUserIdKeyName: "beemz-admin-userId",
};